/**
 * Get a cookie value by name
 */
const getCookie = (name: string): string | null => {
  if (typeof document === "undefined") {
    return null;
  }
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(";").shift();
    return cookieValue || null;
  }
  return null;
};

const NSA_NOS_UI_PATH = "/digital/nsa/nos/";
const NGD_NOS_UI_PATH = "/nextgendigital/nos/";

const isNosUiPath = (): boolean => {
  const pathname = window.location.pathname.toLowerCase();
  return (
    pathname.includes(NSA_NOS_UI_PATH) ||
    pathname.includes(NGD_NOS_UI_PATH)
  );
};

/**
 * Check if the user is logged in.
 * Uses the "loggedIn" cookie; also treats NOS UI paths as eligible so script-injector
 * can load vzGPT as a fallback when the cookie is absent.
 */
export const isLoggedIn = (): boolean => {
  if (getCookie("loggedIn") === "true") {
    return true;
  }
  return isNosUiPath();
};
